export class TeamAttendanceModel {
  mode: number; 
  userId: number;
  ifcId: number;
  teamAttendanceId: number;
  faultId: number;
  attendOrgUnitId: number;
  assignmentId: number;
  teamsId: string;
  teamName: string; 
  personId: number;
  personName: string;
  teamAllocatedDateTime: string;
  reAllocatedDateTime: string;
  tfcRaisedStatusId: string;
  assignmentStatus: string;
  activeStatusId: string;
  teamListStatus: number;
  advisedDateTime: string;
  availableDateTime: string;
  eta: string;
  arrivalSiteDateTime: string;
  commencedDateTime: string;
  completedDateTime: string;
  leftSiteDateTime: string;
  placeId: number;
  placeName: string;  
  disId: number;
}
export class AssignmentsPutModel {
  userId?: number;
  faultAssignmentId?: number;
  linkId?: number;
  isPrimaryAsset?: boolean;
  isGoldenAsset?: boolean;
  assetTypeNode?: number;
  eqId?: number;
  maintOrgUnitId?: number;
  startElrId?: number;
  endElrId?: number;
  startYards?: number;
  endYards?: number;
  startMiles?: number;
  endMiles?: number;
  symptomId?: number;
  bridgeId?: number;
  failureTotalityId?: number;
  special1?: string;
  special2?: string;
  ccil?: string;
  postalCode?: string;
  latitude?: number;
  longitude?: number;
  locationId?: number;
  isAssetUnverified?: boolean;
  isAssetNotApplicable?: boolean;
  unOrNAEqComments?: string;
  statusId?: number;
  suffixId?: number;
  disId?: number;  
  isActive: boolean;
  isDelete: boolean;
  inActiveComments?: string;

  eqNo?: string;
  eqName?: string;
  eqDesc?: string;
  egiId?: number;
  elrRef?: string;
  disName?: string;
  suffixName?: string;
  egiName?: string;
  placeId?: number;
  placeName?: string;
  symptomName?: string;
  statusName?: string;
  isAssetHighlighted?: boolean;
}